export const calculateDiscount = (finalPrice: number, regularPrice:number): string => {
  return `-${100 - (Math.round((finalPrice / regularPrice) * 100))}%`
}
